<template>
  <div class="padres-container">
    <div class="overlay-rosado" />
    <br><br>

    <!-- Texto Padres -->
    <div class="bloque-texto">
      <div ref="texto0Ref" class="texto-container texto-novia">
        <span class="novia">Agradezco a mis Padres</span><br>
      </div>

      <div ref="texto1Ref" class="texto-container text">
        <span class="texto-container3"></span><br>
        Alejandro Sánchez <br>Ericka Muro Gamillo<br>
      </div>
    </div>

    <!-- Texto Padrinos -->
    <div class="bloque-texto">
      <div ref="texto2Ref" class="texto-container texto-novia">
        <span class="novia">Mis Padrinos</span><br>
      </div>

      <div class="padrinos-grid" ref="texto3Ref">
  <div class="padrino-bloque" ref="padrino1Ref">
    <p><strong></strong><br>Jesús Manuel Amador Lazo </p>
    <p><strong></strong><br> Gloria Isela Gamillo de Amador</p>
  </div>
  <div class="padrino-bloque" ref="padrino2Ref">
    <p><strong></strong><br>Eduardo Muro Gamillo </p>
    <p><strong></strong><br> Carmen Angélica García Talavera</p>
  </div>
</div>

    </div>

    <!-- Separador -->
    <img ref="separadorRef" src="@/assets/separador.png" class="separador-final" alt="Separador" />

    <!-- Mariposas -->
    <img ref="mariposa1" src="@/assets/elementos2.png" class="mariposa mariposa1" />
    <img ref="mariposa2" src="@/assets/elementos2.png" class="mariposa mariposa2" />
    <img ref="mariposa3" src="@/assets/elementos2.png" class="mariposa mariposa3" />
  </div>
</template>


<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'BienvenidaPadresPage',
  setup() {
    const refs = {
      texto0Ref: ref(null),
      texto1Ref: ref(null),
      texto2Ref: ref(null),
      padrino1Ref: ref(null),
      padrino2Ref: ref(null),
      separadorRef: ref(null),
      mariposa1: ref(null),
      mariposa2: ref(null),
      mariposa3: ref(null),
    }

    const observeWithGsap = (element, animationFn, delay = 0) => {
      const el = element.value
      if (!el) return

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            animationFn(el, delay)
            observer.unobserve(el)
          }
        },
        { threshold: 0.2 }
      )

      el.style.opacity = 0
      el.style.transform = 'translateY(50px)'
      observer.observe(el)
    }

    const fadeInUp = (el, delay) => {
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 1.2,
        ease: 'power3.out',
        delay,
      })
    }

    onMounted(() => {
      observeWithGsap(refs.texto0Ref, fadeInUp, 0)
      observeWithGsap(refs.texto1Ref, fadeInUp, 0.3)
      observeWithGsap(refs.texto2Ref, fadeInUp, 0.5)
      observeWithGsap(refs.padrino1Ref, fadeInUp, 0.7)
      observeWithGsap(refs.padrino2Ref, fadeInUp, 0.9)
      observeWithGsap(refs.separadorRef, fadeInUp, 1.1)

      const mariposas = [refs.mariposa1, refs.mariposa2, refs.mariposa3]
      mariposas.forEach((m, i) => {
        gsap.to(m.value, {
          opacity: 1,
          y: -20,
          duration: 3,
          delay: 1.5 + i * 0.5,
          ease: "power1.out",
          repeat: -1,
          yoyo: true
        })
      })
    })

    return { ...refs }
  },
}
</script>

<style scoped>
.padres-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 0;
  overflow: hidden;
}

.overlay-rosado {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.bloque-texto {
  margin-bottom: 40px;
  text-align: center;
}

.texto-container {
  position: relative;
  z-index: 2;
  padding: 10px;
  width: 100%;
  max-width: 600px;
  font-family: 'Dancing Script', sans-serif;
  font-size: 18px;
  color: #5c4b51;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.4s ease;
  margin: 0 auto;
}

.novia {
  font-family: 'FeelingPassionate', cursive;
  font-size: 32px;
  color: #4d506e;
}

.text {
  font-size: 28px;
  color: #9c916b;
  font-family: "Dancing Script", sans-serif;
}

.separador-final {
  width: 80vw;
  height: auto;
  margin: 0 auto;
  display: block;
  transform: translateY(50px);
  opacity: 0;
  z-index: -2;
}

.mariposa {
  position: absolute;
  width: 60px;
  opacity: 0;
  z-index: 1;
}

.mariposa1 { top: 20%; left: 10%; }
.mariposa2 { top: 45%; right: 15%; }
.mariposa3 { top: 85%; left: 15%; }
.padrinos-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  text-align: center;
  margin-top: 20px;
  max-width: 800px;
  width: 100%;
}

.padrino-bloque {
  color: #9c916b;
  font-family: "Dancing Script", sans-serif;
  font-size: 20px;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.4s ease;
}

/* 👇 Fuerza dos columnas incluso en móvil */
@media (max-width: 600px) {
  .padrinos-grid {
    grid-template-columns: 1fr 1fr !important;
    gap: 20px;
  }

  .padrino-bloque {
    font-size: 15px;
  }
}

</style>
